import { SetState } from 'zustand';
import React from 'react';
import { generateRandomId } from '../helpers';

export interface IMessageData {
  type: string;
  callback?: () => void;
  childName?: string;
  messageText?: string;
  messageTitle?: string;
  iconSource?: any;
  needSpinner?: boolean;
  autoCloseTimeout?: number;
  processingText?: string;
  useLottie?: boolean;
  reqId?: string;

  // POP-UP
  secondaryButtonText?: string;
  secondaryButtonClassName?: string;
  mainButtonText?: string;
  isLoading?: boolean;
  buttonClassName?: string;
  mainButtonClassName?: string;
  containerClassName?: string;
  overrideContainerClassName?: boolean;
  titleClassName?: string;
  messageTextClassName?: string;
  pictureClassName?: string;
  secondaryHandleState?: () => void;
  handleManualLoading?: () => void;
  needIconX?: boolean;
  xIconSrc?: string;
  xButtonClassName?: string;
  popupHeight?: string;

  // User Message
  customModal?: React.ReactNode;
}

export interface IUserMessageSlice {
  messageObject: IMessageData;
  setMessageObject: (messageObject: IMessageData) => void;
  resetUserMessageSlice: () => void;
}

const createUserMessageSlice = (set: SetState<IUserMessageSlice>) => ({
  messageObject: {
    type: '',
  },
  resetUserMessageSlice: () => {
    set({
      messageObject: {
        type: '',
        customModal: undefined,
      },
    });
  },
  setMessageObject: (messageObject: IMessageData) => {
    set({
      messageObject: { ...messageObject, reqId: generateRandomId() },
    });
  },
});

export default createUserMessageSlice;
